export default __webpack_public_path__ + "static/media/joost_m.8c965e2e.jpg";